import { render, staticRenderFns } from "./ItemSheet.vue?vue&type=template&id=2c0eabc2&"
import script from "./ItemSheet.vue?vue&type=script&lang=ts&"
export * from "./ItemSheet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports